<ng-container *ngIf="showCookiesTermsDialog">
  <div class="cookies-banner-container">
    <p class="message" [innerHTML]="'CookiesAndTerms.Content' | translate | safe: 'html'"></p>

    <button class="btn accept"
            (click)="acceptCookiesAndTerms()"
            [innerHTML]="'CookiesAndTerms.Button' | translate | safe: 'html'"
    ></button>
  </div>
</ng-container>
